<script setup lang="ts">
import styles from '@/assets/sass/components/mainnav.module.scss';
import SubMenuShell from '@/components/SubMenuShell.vue';
</script>
<template>
    <nav :class="styles.mainnav">
        <div :class="styles.inner">

        </div>
        <SubMenuShell />
    </nav>
</template>
